import { render, staticRenderFns } from "./PendoTracker.vue?vue&type=template&id=23c2538e"
import script from "./PendoTracker.vue?vue&type=script&lang=js"
export * from "./PendoTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports